import { render, staticRenderFns } from "./SortableTableHeading.vue?vue&type=template&id=285d1b55&scoped=true&"
import script from "./SortableTableHeading.vue?vue&type=script&lang=js&"
export * from "./SortableTableHeading.vue?vue&type=script&lang=js&"
import style0 from "./SortableTableHeading.vue?vue&type=style&index=0&id=285d1b55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285d1b55",
  null
  
)

export default component.exports